export default selected => {
    if (!selected) {
        return {};
    }

    return Object.entries(selected).reduce((acc, [k, v]) => {
        return {
            ...acc,
            [k]:
                v instanceof Object
                    ? Object.entries(v).reduce((acc2, val) => {
                          acc2.push(val[0]);
                          return acc2;
                      }, [])
                    : v,
        };
    }, {});
};
